import GoodDataDashboardContainer from "./GoodDataDashboardContainer";
export { GoodDataDashboardContainer };
